export default __webpack_public_path__ + "static/media/phoneIcon.9cb02202.svg";